<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true //加载完判断是否需要重新刷新当前页面
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    // 刷新组件
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    // 判断滚动条宽度
    getGun: function(){
      var odiv = document.createElement('div'),//创建一个div
      styles = {
        width: '100px',
        height: '100px',
        overflowY: 'scroll'//让他有滚动条
      }, i, scrollbarWidth;
      for (i in styles) odiv.style[i] = styles[i];
      document.body.appendChild(odiv);//把div添加到body中
      scrollbarWidth = odiv.offsetWidth - odiv.clientWidth;//相减
      odiv.remove();//移除创建的div
      this.$store.state.scrollbarWidth = scrollbarWidth;
    },
  },

  mounted() {
    if(localStorage.getItem("pageType")){
      this.$store.state.pageType = localStorage.getItem("pageType");
    }else{
      this.$store.state.pageType = 1;
    }
    if(document.body.clientWidth <= 750){
      this.$store.state.sizeType = "phone";
    }else{
      this.$store.state.sizeType = "pc";
    }
  },
  updated() {
    if(!this.$route.query.index){
      window.scroll(0, 0);
    }
  },
}
</script>

<style>
body,html{
  height: 100%;
  /* font-family: Roboto, Arial, Helvetica, "Microsoft YaHei New", "Microsoft Yahei", 微软雅黑, 宋体, SimSun, STXihei, 华文细黑, sans-serif; */
  font-family: 微软雅黑;
}
body,
div,
p,
span,
ul,
li,
iframe,
header,
footer,
a {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

ul,
li {
  list-style: none;
}

a {
  text-decoration: none;
}

img {
  display: block;
  object-fit: cover;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}

.scroll {
  overflow-y: scroll;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}

div,
input,
textarea,
p,
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

audio::-webkit-media-controls-enclosure{
  background: none;
}

.oneLine{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.twoLine{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.xiahua{
  text-decoration: underline;
}

.nodata{
  font-size: 24px;
  text-align: center;
  padding: 100px;
  font-weight: 600;
  width: 100%;
}

/* 加载中样式修改 */
.ivu-spin-fullscreen-wrapper{
  opacity: 0;
}

.ivu-form .ivu-form-item-label{
  font-size: 14px;
}

.page{
  width: 100%;
  text-align: right;
  padding: 30px;
}

textarea.ivu-input{
  font-size: 12px;
}

.ivu-carousel-dots li button{
  background: none;
  width: 40px;
  height: 4px;
  border-radius: 2px;
  border: 1px solid #fff;
}

.ivu-carousel-dots li.ivu-carousel-active>button{
  width: 40px;
  background-color: #fff;
}

.ivu-icon{
  line-height: 32px;
}

.ivu-poptip-inner{
  background-color: #F6FAFF;
  border-radius: 10px;
}

.ivu-poptip-body{
  padding: 30px 40px;
}

.pc{
  display: block !important;
}

.phone{
  display: none !important;
}

@media screen and ( max-width: 750px ) {
  .pc{
    display: none !important;
  }

  .phone{
    display: block !important;
  }

  .noData{
    padding: 1rem;
    font-size: 0.4rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue